import React, {
  useState,
} from 'react';

import {
  Flex,
} from 'web-styled';

import {
  Icon,
} from 'web-components';

import TextField from './TextField';
import * as S from './styled';

export type InputProps = {
  width?: string;
};

const PasswordField = ({ width, ...rest }: InputProps) => {
  const [visible, setVisible] = useState(false);

  return (
    <Flex width={width}>
      <TextField
        {...rest}
        type={visible ? 'text' : 'password'}
        width={width}
      />
      <S.RightIcon
        top={rest.label ? 42 : 13}
        onClick={() => setVisible(!visible)}
      >
        <Icon
          type={visible ? 'fas fa-eye-slash' : 'fas fa-eye'}
        />
      </S.RightIcon>
    </Flex>
  );
};

PasswordField.defaultProps = {
  width: '100%',
};

export default PasswordField;
